(() => {
  const { currency, moneySample } = document.documentElement.dataset;
  // Shopify's money filter supplies the active market's formatting, not the browser locale.
  const number = moneySample?.match(/\d[\d\s.,'’]*\d/);
  const fallback = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
  if (!number) { window.VelvetMoney = { format: cents => fallback.format(cents / 100) }; return; }
  const sample = number[0];
  const decimal = sample.match(/([^\d])89$/)?.[1];
  const integer = decimal ? sample.slice(0, -3) : sample;
  const group = integer.match(/[^\d]/)?.[0] || '';
  const prefix = moneySample.slice(0, number.index), suffix = moneySample.slice(number.index + sample.length);
  window.VelvetMoney = {
    format(cents) {
      const [whole, fraction] = (Math.abs(cents) / 100).toFixed(decimal ? 2 : 0).split('.');
      const grouped = group ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, group) : whole;
      return `${cents < 0 ? '−' : ''}${prefix}${grouped}${decimal ? decimal + fraction : ''}${suffix}`;
    }
  };
})();
